"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setClassesData = void 0;
const actionTypes_1 = require("./actionTypes");
const setClassesData = (classes) => {
    classes?.id && localStorage.setItem('classes', classes.id);
    return {
        type: actionTypes_1.SET_CLASSES_DATA,
        classes,
    };
};
exports.setClassesData = setClassesData;
